var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FeedbackProvider',{attrs:{"sendingState":_vm.sendingState}},[_c('v-switch',{staticClass:"basic-control-switch",attrs:{"color":"accent","inset":"","hide-details":"","input-value":_vm.state,"disabled":_vm.isDisabled},nativeOn:{"!click":function($event){return _vm.handleState($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }